/** 菜单 */
export default{
    home: "หน้าแรก",
    systemMonitoring: "系统监控",
    systemTools: "系统工具", // 系统工具
    platformManage: "平台管理", // 平台管理
    workbench: "ฟังก์ชั่นทั่วไป", // 工作台
    organization: "องค์กร", // 组织架构
    entityManage: "การจัดการร้านค้า", // 实体管理
    enterpriseEquipment: "อุปกรณ์องค์กร", // 企业设备
    systemManage: "การจัดการระบบ", // 系统管理
        region: "行政区域", // 行政区域
        userManage: "การจัดการบัญชี", // 用户管理
        roleManage: "การจัดการบทบาท", // 角色管理
        deptManage: "การจัดการแผนก", // 部门管理
        postManage: "การจัดการงาน", // 岗位管理
        dictManage: "การจัดการพจนานุกรม", // 字典管理
        counterManage: "การจัดการอุปกรณ์", // 计数器管理
        notice: "ประกาศ", // 通知公告
        i18nConfig: "i18n config", // 国际化配置
    financeManage: "财务管理", // 财务管理
        applicationInfo: "应用信息", // 引用信息
        merchantInfo: "商户信息", // 商户信息
        payChannel: "支付渠道", // 支付渠道
        payPackage: "支付套餐", // 支付套餐
        payNotice: "支付通知", // 支付通知
        merchantNotice: "商户通知", // 商户通知
        payOrder: "支付订单", // 支付订单
        payOrderExtend: "支付订单扩展", // 支付订单扩展
        refundOrder: "退款订单", // 退款订单
    dataCorrection: "การแก้ไขข้อมูล", // 数据修正
        equipmentData: "ข้อมูลการถ่ายโอนอุปกรณ์", // 设备传输数据
        minuteDimension: "ข้อมูลรายนาที", // 五分钟维度
        hourDimension: "ข้อมูลรายชั่วโมง", // 小时维度
        hourShadowDimension: "ข้อมูลเสมือนรายชั่วโมง", // 小时影子维度
        dayDimension: "ข้อมูลรายวัน", // 天维度
    passengerFlow: "การจัดการการไหลของผู้โดยสาร", // 客流管理
        screenSetting: "การตั้งค่าหน้าจอขนาดใหญ่", // 大屏设置
        passagewayManage: "การจัดการเข้าและออก", // 出入口管理
        faceCaptureData: "人脸抓拍数据", //人脸抓拍数据
    logManage: "การจัดการบันทึก", // 日志管理
        operateLog: "บันทึกการดำเนินงาน", // 操作日志
        loginLog: 'บันทึกการเข้าสู่ระบบ', // 登录日志
    developerCentre: "นักพัฒนา", // 开发者
}